<template lang="pug">
  .activity-status-update
    .row
      .col
        .activity-avatar
          UserAvatar(:user="activity.user")
      .col.max
        .activity-header
          .row.apart
            .col
              span.creator {{ activity.user.fullName }} 
              span marked this as 
              StatusLabel(:status="activity.status")
            .col
              span.created {{ activity.created | moment("from") }}
        .activity-body(v-if="activity.comment", v-html="commentFormatted")

</template>

<script>

import StatusLabel from '@/components/StatusLabel'

const urlRegex = /(https?:\/\/[^\s]+)/g

export default {
  name: 'ActivityStatusUpdated',
  components: {
    StatusLabel
  },
  props: {
    activity: Object
  },
  computed: {
    commentFormatted () {
      let comment = null
      if (this.activity.comment) {
        comment = this.activity.comment.replace(/\n/g, '<br/>')
        comment = comment.replace(urlRegex, '<a target="_blank" href="$1">$1</a>')
      }
      console.log('comment', comment)
      return comment
    }
  },
  mounted () {
    //console.log(this.activity)
  }}
</script>

<style scoped lang="stylus">
  .activity-status-update
    border-bottom $border-default
    display block
    margin-bottom $spacing
    padding $spacing-4 0
    
    .activity-header
      color $text-light
      
      .status
        margin-left 2px
        vertical-align middle

    .creator
      font-size $text-size-small
      line-height $text-size-default
    .created
      font-size $text-size-smaller
      line-height $text-size-default

    .activity-body
      color $text-light
      line-height 22px
      margin-bottom $spacing
      padding $spacing-2 0
      a
        &:hover
          text-decoration underline

  .activity-avatar
    width 50px

</style>
